/**
 * Report what a File-column copy actually did.
 *
 * Adding from a column brings across a batch, so "it worked" is rarely the
 * whole story: some files are not PDFs, some fail to download, and the batch
 * can hit the document cap partway through. A column that quietly brought 2 of
 * its 5 files across is worse than one that says which 3 it left behind — the
 * user is about to send these for signature and will not re-count them.
 *
 * Shared by both wizards, which report the same server response the same way.
 */

/** Join names for a notice, truncating so one bad column can't produce a wall. */
function nameList(names, limit = 3) {
  const shown = names.slice(0, limit);
  const rest = names.length - shown.length;
  return rest > 0 ? `${shown.join(', ')} and ${rest} more` : shown.join(', ');
}

export function reportColumnCopy(monday, res, columnTitle) {
  const added = Number(res?.added ?? 0);
  const skipped = res?.skipped || [];
  const failed = res?.failed || [];
  const where = columnTitle ? `“${columnTitle}”` : 'that column';

  monday.execute('notice', {
    message: `Added ${added} document${added === 1 ? '' : 's'} from ${where}.`,
    type: 'success',
    timeout: 4000,
  });

  // Separate notices, and both errors rather than info: each is a file the user
  // expected to be signing and now is not.
  if (skipped.length) {
    monday.execute('notice', {
      message: `Not a PDF, so left behind: ${nameList(skipped)}. Only PDFs can be signed.`,
      type: 'error',
      timeout: 7000,
    });
  }
  if (failed.length) {
    monday.execute('notice', {
      message: `Could not be read as a PDF: ${nameList(failed)}.`,
      type: 'error',
      timeout: 7000,
    });
  }
  if (res?.capped) {
    monday.execute('notice', {
      message: `The document limit was reached, so the rest of ${where} was not added.`,
      type: 'error',
      timeout: 7000,
    });
  }
}
